import { FC } from "react";
import { Form, Input } from "antd";
import Carrier from "@Components/Carrier/Carrier";
import { withFloatingLabel } from "src/HOC";
import HotelSelectContent from "../../HotelSelectContent/HotelSelectContent";

const FloatingTextArea = withFloatingLabel(Input);

const LocationComponentMob: FC<any> = ({ name, icon: Icon, label, hasError, ...props }) => {
  const value = Form.useWatch(name);

  return (
    <Carrier
      label={label}
      renderTrigger={({ open }) => (
        <div className={`flex w-full flex-1 items-start gap-1 px-1 border-b border-border-default ${hasError ? "text-font-danger" : "text-icon-minimal"}`}>
          <Icon className="h-4! w-4! mt-4" />
          <FloatingTextArea
            label={label}
            readOnly
            value={value?.label}
            onClick={open}
            className="text-font-default! border-none! outline-none! font-semibold shadow-none! resize-none! whitespace-pre-wrap! pt-5! pb-1! px-3! w-full cursor-pointer"
          />
        </div>
      )}
      renderSheet={({ close }) => <HotelSelectContent name={name} icon={Icon} label={label} closeSheet={close} {...props} />}
    />
  );
};

export default LocationComponentMob;
